import { Heading, Text, Box } from "@chakra-ui/react";

import Container from "components/Chakra/Container";
import MetaHead from "components/MetaHead";

export const WhistleblowingPage: React.FC = () => (
  <>
    <MetaHead
      title="Whistleblowing"
      description="Společnost UlovDomov.cz s.r.o., se sídlem v Brně, Rašínova 103/2, okres Brno-město, PSČ 602 00, IČ: 29300631, zapsaná v obchodním rejstříku vedeném Krajským soudem v Brně, sp. zn. C72444"
    />
    <Container>
      <Heading as="h1" pt="90px">
        Informace dle zákona č. 171/2023 Sb., o&nbsp;ochraně oznamovatelů
      </Heading>
      <Box
        px="5%"
        mt="50px"
        mb="80px"
        borderColor="ud-grey-200"
        borderWidth="1px"
        borderRadius="8px"
        py="10"
        sx={{ "> *:not(:first-of-type)": { pt: "20px" } }}
      >
        <Text>
          Společnost UlovDomov.cz s.r.o. IČO 29300631, se sídlem Lazaretní
          925/9, 615 00, Brno.
        </Text>
        <Text>Oznamovatel může učinit Oznámení především:</Text>
        <Text as="ul" pl="20px">
          <Text as="li">
            prostřednictvím e-mailu <b>whistleblowing@ulovdomov.cz</b>;
          </Text>
          <Text as="li">
            písemně prostřednictvím schránky umístěné u vchodu do budovy nebo
            zasláním poštou na adresu Společnosti – takto podané oznámení musí
            být v zalepené obálce, která musí být čitelně označena nápisem
            „Whistleblowing – NEOTVÍRAT“;
          </Text>
          <Text as="li">
            telefonicky na tel. <b>+420 771 299 061</b>;
          </Text>
          <Text as="li">
            ústně v místě sídla Společnosti či v jiném místě stanoveném na
            základě dohody s Příslušnou osobou; podání ústního oznámení bude
            Oznamovateli umožněno v přiměřené lhůtě, nejdéle však do 14 dnů ode
            dne, kdy o to Oznamovatel požádal.
          </Text>
        </Text>
        <Text>
          Dotčené osoby, které mají informace o Podezřelé skutečnosti, mohou
          učinit Oznámení dle Směrnice Společnosti, a/nebo učinit Oznámení
          prostřednictvím vnějšího oznamovacího systému vedeného Ministerstvem
          spravedlnosti. K Oznámením o porušení zákona č. 253/2008 Sb., o
          některých opatřeních proti legalizaci výnosů z trestné činnosti a
          financování terorismu nesmí být využit oznamovací systém Ministerstva
          spravedlnosti, ale musí být takové oznámení učiněno prostřednictvím
          Finančního analytického úřadu.
        </Text>
        <Text>
          Příslušnou osobou je <b>Jiří Malý</b>, e-mail 
          <b>whistleblowing@ulovdomov.cz</b>, tel. <b>+420 771 299 061</b>.
          Pokud se Podezřelá skutečnost uvedená v Oznámení týká této Příslušné
          osoby či by tato Příslušná osoba mohla být dle odůvodněného názoru
          Oznamovatele ve střetu zájmů, pak Oznámení přijímá a další povinnosti
          Příslušné osoby dle této Směrnice vykonává <b>Miroslava Kačerová</b>,
          e-mail <b>whistleblowing@idealninajemce.cz</b>, tel.{" "}
          <b>+420 775 778 195</b>.
        </Text>
      </Box>
    </Container>
  </>
);
